/* US Multi campaign UI guard. Shopify BXGY, not this script, enforces pricing. */
(() => {
  'use strict';
  const ID = '312359';
  const MULTI = '31659579113581';
  const QUALIFIERS = new Set([MULTI, '12110746157165', '39591522893933']);
  const END = Date.parse('2026-10-30T05:00:00Z');
  const attached = new WeakSet();
  let widget;
  let pending = false;
  let pendingTimer;
  function canOffer(current) {
    if (window.Shopify?.country !== 'US' || Date.now() >= END) return false;
    const items = window.Rebuy?.Cart?.items?.();
    if (!Array.isArray(items)) return false;
    let qualifying = 0;
    let oneTimeMulti = 0;
    for (const item of items) {
      const id = String(item.variant_id || item.id);
      const quantity = Number(item.quantity) || 0;
      if (QUALIFIERS.has(id)) qualifying += quantity;
      if (id === MULTI && !item.selling_plan_allocation && !item.selling_plan) oneTimeMulti += quantity;
    }
    // Any existing eligible pair already receives the single native discount.
    if (qualifying < 1 || (qualifying >= 2 && oneTimeMulti >= 1)) return false;
    return Boolean(current?.data?.metadata?.matched_rules?.length) &&
      current.data.products?.some(product => String(product.id) === '4451932864621');
  }
  function releasePending() {
    pending = false;
    clearTimeout(pendingTimer);
  }
  function attach(current) {
    if (!current || String(current.id) !== ID || attached.has(current)) return;
    attached.add(current);
    widget = current;
    const originalShow = current.show;
    const originalAdd = current.addToCart;
    current.show = function (...args) {
      if (!pending && canOffer(this)) return originalShow.apply(this, args);
    };
    current.addToCart = function (product, callback) {
      if (pending || !canOffer(this)) return;
      pending = true;
      pendingTimer = setTimeout(releasePending, 30000);
      try {
        return originalAdd.call(this, product, (...args) => {
          releasePending();
          if (typeof callback === 'function') callback(...args);
        });
      } catch (error) {
        releasePending();
        throw error;
      }
    };
  }
  for (const eventName of ['rebuy.init', 'rebuy.beforeReady', 'rebuy.ready']) {
    document.addEventListener(eventName, event => attach(event.detail?.widget));
  }
  document.addEventListener('rebuy.add', event => {
    const current = event.detail?.widget;
    if (String(current?.id) !== ID) return;
    releasePending();
    current.hide();
    window.Rebuy?.SmartCart?.show?.();
  });
  document.addEventListener('rebuy:cart.change', () => {
    if (widget?.data?.visible && !canOffer(widget)) widget.hide();
  });
  for (const current of window.Rebuy?.widgets || []) attach(current);
})();
